import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { Observable, of } from 'rxjs'
import { filter, map, startWith, switchMap } from 'rxjs/operators'
import { ICON_TYPE } from '@spartacus/storefront'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { CommonService } from '../../../shared/services/common.service'
import { QuoteCartService } from '../../quote/quote-services/quote-cart.service';
import { QuoteCartFacade } from './store/mini-quote-cart.facade';

@Component({
  standalone: false,
  // tslint:disable-next-line:component-selector
  selector: 'cx-mini-cart',
  templateUrl: './mini-cart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniCartComponent implements OnInit {
  constructor(
    protected activeCartService: ActiveCartFacade,
    protected cartService: ActiveCartFacade,
    private authService: AuthService,

    private cRef: ChangeDetectorRef,
    private globalMessageService: GlobalMessageService,
    private commonService: CommonService,
    private userAccountFacade: UserAccountFacade,
    private quoteCartService: QuoteCartService,
    private quoteCartFacade: QuoteCartFacade,
  ) {}

  iconTypes = ICON_TYPE
  isShowDivIf = false
  isShowQuoteDivIf = false
  cart: any
  quoteCart$: Observable<any>;

  quantity$: Observable<number> = this.activeCartService.getActive().pipe(
    startWith({ deliveryItemsQuantity: 0 }),
    map((cart) => cart.deliveryItemsQuantity || 0)
  )

  total$: Observable<string> = this.activeCartService.getActive().pipe(
    filter((cart) => !!cart.totalPrice),
    map((cart) => cart.totalPrice.formattedValue)
  )

  user$: Observable<any>
  isLoggedInUser = false

  ngOnInit() {
    this.cartService.getActive().subscribe(
      (success) => {
        this.cart = success;
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0);
      }
    )

    this.quoteCartFacade.loadCart();
    this.quoteCart$ = this.quoteCartFacade.getCartData();

    this.user$ = this.authService.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccountFacade.get()
        } else {
          return of(undefined)
        }
      })
    )

    this.user$.subscribe(
      (res) => {
        if (res) {
          this.isLoggedInUser = true
          this.cRef.detectChanges()
        } else {
          this.isLoggedInUser = false
          this.cRef.detectChanges()
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )

    this.closeMenuOnOtherMenuEvent()
  }

  closeMenuOnOtherMenuEvent() {
    this.commonService.closeMenu.subscribe((menuStatus) => {
      this.isShowDivIf = menuStatus.miniCart
      this.cRef.detectChanges()
    })
  }

  navigateProducts(event) {
    this.isShowDivIf = true
    this.isShowQuoteDivIf = false
    //now close the Main Menu if open
    this.commonService.closeMenu.next({
      profileMenu: false,
      miniCart: true,
      megaNavMenu: false,
      changeAccMenu: false,
    })

    event.stopPropagation()
  }

  navigateQuoteProducts(event) {
    this.isShowQuoteDivIf = true
    this.isShowDivIf = false
    event.stopPropagation()
  }

  navigationOne(event) {
    if (event.pageX < 800 || event.pageX > 1200) {
      this.isShowDivIf = false
    }
  }
  navigationQuote(event) {
    if (event.pageX < 800 || event.pageX > 1200) {
      this.isShowQuoteDivIf = false
    }
  }
  closeMiniCartDetails(event) {
    this.isShowDivIf = false
  }
  closeMiniQuoteCartDetails(event) {
    this.isShowQuoteDivIf = false
  }
  miniQuoteCartReload(event) {
    
  }
}
